var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.303,
    height: 51.6,
    viewBox: "0 0 56.303 51.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shopping_List",
    "data-name": "Shopping List",
    transform: "translate(-386.157 -1682.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M392.791,1701.959a6.634,6.634,0,1,0,6.634,6.634A6.647,6.647,0,0,0,392.791,1701.959Zm0,10.313a3.678,3.678,0,1,1,3.679-3.679A3.685,3.685,0,0,1,392.791,1712.272Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M392.791,1682.647a6.633,6.633,0,1,0,6.634,6.633A6.646,6.646,0,0,0,392.791,1682.647Zm0,10.313a3.679,3.679,0,1,1,3.679-3.68A3.686,3.686,0,0,1,392.791,1692.96Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M392.791,1720.98a6.633,6.633,0,1,0,6.634,6.634A6.646,6.646,0,0,0,392.791,1720.98Zm0,10.3a3.679,3.679,0,1,1,3.679-3.679A3.685,3.685,0,0,1,392.791,1731.281Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M440.964,1704.287H406.758a1.484,1.484,0,0,0,0,2.967h34.206a1.484,1.484,0,1,0,0-2.967Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M440.964,1709.944H406.758a1.484,1.484,0,0,0,0,2.967h34.206a1.484,1.484,0,1,0,0-2.967Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M440.964,1723.284H406.758a1.483,1.483,0,0,0,0,2.967h34.206a1.483,1.483,0,1,0,0-2.967Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M440.964,1728.953H406.758a1.484,1.484,0,0,0,0,2.967h34.206a1.484,1.484,0,1,0,0-2.967Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M406.771,1688.234h34.206a1.484,1.484,0,0,0,0-2.967H406.758a1.484,1.484,0,0,0,.013,2.967Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M440.964,1690.936H406.758a1.483,1.483,0,0,0,0,2.967h34.206a1.483,1.483,0,1,0,0-2.967Z",
    fill: "#666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCategory);
export default __webpack_public_path__ + "static/media/ic_category.cffe7f0a.svg";
export { ForwardRef as ReactComponent };